<svelte:head>
	<title>Zarpar | Política de cookies</title>
	<meta name="description" content="Política de cookies" />
</svelte:head>

<div class="mx-auto max-w-3xl px-2 py-14 md:px-0">
	<div class="max-w-150 relative mx-auto pb-8 text-center">
		<h1 class="text-4xl font-extrabold tracking-tight text-slate-900 sm:text-5xl">
			Política de cookies
		</h1>
		<p class="mt-4 text-base leading-7 text-slate-600">Ultima actualización 01/09/2025</p>
	</div>
	<div class="max-w-160 mx-auto pb-14 underline">
		<a href="https://zarpar.eu">https://zarpar.eu</a>
	</div>
	<div
		class="prose prose-sm prose-slate prose-a:font-semibold prose-a:text-sky-500 hover:prose-a:text-sky-600 max-w-160 mx-auto"
	>
		<ol class="list-inside list-decimal space-y-2">
			<li class="font-semibold">¿Qué es una cookie y cuál es su función?</li>
			<p>
				Una cookie es un pequeño fragmento de texto que los sitios web envían al navegador y que se
				descarga en el ordenador, smartphone, tablet o dispositivo electrónico del usuario cuando
				éste accede a una página web.
			</p>
			<p>
				Las cookies permiten almacenar y recuperar información sobre los visitantes a la página web,
				como por ejemplo el idioma y permiten mantener un registro sobre los hábitos de navegación
				del usuario y sus preferencias.
			</p>
			<p>
				Las cookies se utilizan, por ejemplo, para gestionar la sesión del usuario (reduciendo el
				número de veces que tiene que incluir su contraseña), mejorar los servicios ofrecidos, o
				para adecuar los contenidos de una página web a sus preferencias.
			</p>
			<p>
				El titular de esta web utiliza cookies para facilitar la navegación por la misma y obtener
				información acerca de las visitas.
			</p>
			<li class="mt-4 font-semibold">¿Qué tipos de cookies existen?</li>
			<p>En función de su finalidad:</p>
			<ul class="ml-4 mt-2 list-disc">
				<li>Técnicas o funcionales: para permitir el funcionamiento del sitio web.</li>
				<li>
					De preferencias o personalización: para adaptar el sitio web a las preferencias del
					usuario.
				</li>
				<li>
					Analíticas: para analizar los hábitos y comportamiento del usuario durante la navegación.
				</li>
				<li>Publicitarias: para obtener información que permita mostrar publicidad adaptada.</li>
				<li>
					De redes sociales: cookies establecidas por los servicios de redes sociales para que el
					usuario pueda compartir el contenido del sitio web en sus plataformas. En caso de no ser
					aceptadas, es probable que no se visualicen o se puedan utilizar las opciones para
					compartir contenido en RRSS.
				</li>
			</ul>
			<p>En función de su origen o quién las gestiona:</p>
			<ul class="ml-4 mt-2 list-disc">
				<li>
					Propias: cuando se envían a tu navegador a través de nuestros equipos o dominios web.
				</li>
				<li>
					De terceros: cuando se descargan como consecuencia de navegar en el sitio web, pero tienen
					origen fuera del mismo y son gestionadas por un tercero, como por ejemplo Google.
				</li>
			</ul>
			<p>En función de su duración o tiempo que permanecen en el dispositivo:</p>
			<ul class="ml-4 mt-2 list-disc">
				<li>
					De sesión: permanecen en tu dispositivo sólo hasta que abandonas la página web o cierras
					el navegador.
				</li>
				<li>
					Persistentes: se mantienen en tu dispositivo hasta que expiran, recopilando información
					durante ese periodo de tiempo cada vez que realizas una nueva visita. Estas cookies dejan
					de funcionar cuando se alcanza su fecha de caducidad.
				</li>
			</ul>
			<li class="mt-4 font-semibold">¿Qué cookies utilizamos en esta página web?</li>
			<div class="mt-4 overflow-x-auto rounded-lg border border-gray-200 shadow-sm">
				<table class="min-w-full divide-y divide-gray-200">
					<thead class="bg-gray-50">
						<tr>
							<th
								class="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
							>
								Cookie
							</th>
							<th
								class="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
							>
								Finalidad y Descripción
							</th>
							<th
								class="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
							>
								Origen
							</th>
							<th
								class="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
							>
								Duración
							</th>
						</tr>
					</thead>
					<tbody class="divide-y divide-gray-200 bg-white">
						<tr>
							<td class="whitespace-nowrap px-6 py-4 text-sm font-medium text-gray-900">
								PARAGLIDE_LOCALE
							</td>
							<td class="px-6 py-4 text-sm text-gray-900">
								Técnica: permite guardar la preferencia de idioma del usuario
							</td>
							<td class="whitespace-nowrap px-6 py-4 text-sm text-gray-900"> Propia </td>
							<td class="whitespace-nowrap px-6 py-4 text-sm text-gray-900"> 13 meses </td>
						</tr>
						<tr>
							<td class="whitespace-nowrap px-6 py-4 text-sm font-medium text-gray-900">
								ph_phc_*
							</td>
							<td class="px-6 py-4 text-sm text-gray-900">
								Analítica: permite medir la actividad de Usuario
							</td>
							<td class="whitespace-nowrap px-6 py-4 text-sm text-gray-900">
								De terceros: Posthog
							</td>
							<td class="whitespace-nowrap px-6 py-4 text-sm text-gray-900"> 12 meses </td>
						</tr>
					</tbody>
				</table>
			</div>
			<li class="mt-4 font-semibold">¿Cómo configurar o deshabilitar las cookies?</li>
			<p>
				Para que podamos utilizar cookies es necesario el consentimiento del usuario (excepto
				aquellas que son técnicas o necesarias). Al acceder a la web, se mostrará un banner con dos
				opciones o botones: “Aceptar”, “Rechazar”.
			</p>
			<p>
				Si el usuario escoge “Rechazar” se desahabilitara las cookies de analitica y solo se usaran
				las cookies necesarias.
			</p>
			<p>
				Si una vez aceptadas las cookies el Usuario desea cambiar, bloquear o eliminar cookies de
				terceros, deberá hacerlo a través de las opciones de configuración de su navegador de
				internet, que puede encontrar pinchando en los siguientes enlaces:
			</p>
			<ul class="space-y-2">
				<li>
					<a
						href="https://support.google.com/chrome/answer/95647?hl=es"
						target="_blank"
						rel="noopener noreferrer"
						class="font-semibold text-sky-500 underline hover:text-sky-600"
					>
						Google Chrome
					</a>
				</li>
				<li>
					<a
						href="https://support.microsoft.com/es-es/microsoft-edge/eliminar-las-cookies-en-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09"
						target="_blank"
						rel="noopener noreferrer"
						class="font-semibold text-sky-500 underline hover:text-sky-600"
					>
						Microsoft Edge
					</a>
				</li>
				<li>
					<a
						href="https://support.mozilla.org/es/kb/cookies-informacion-que-los-sitios-web-guardan-en-"
						target="_blank"
						rel="noopener noreferrer"
						class="font-semibold text-sky-500 underline hover:text-sky-600"
					>
						Mozilla Firefox
					</a>
				</li>
				<li>
					<a
						href="https://help.opera.com/en/latest/web-preferences/#cookies"
						target="_blank"
						rel="noopener noreferrer"
						class="font-semibold text-sky-500 underline hover:text-sky-600"
					>
						Opera
					</a>
				</li>
				<li>
					<a
						href="https://support.apple.com/es-es/105082"
						target="_blank"
						rel="noopener noreferrer"
						class="font-semibold text-sky-500 underline hover:text-sky-600"
					>
						Safari para iOS (iPhone e iPad)
					</a>
				</li>
				<li>
					<a
						href="https://support.google.com/chrome/answer/114662?hl=es&visit_id=637414732770426667-1584214516&rd=1"
						target="_blank"
						rel="noopener noreferrer"
						class="font-semibold text-sky-500 underline hover:text-sky-600"
					>
						Chrome para Android
					</a>
				</li>
			</ul>
		</ol>
	</div>
</div>
